__turbopack_context__.v({
  "buttonsWrapper": "rNMKAW_buttonsWrapper",
  "inputWrapper": "rNMKAW_inputWrapper",
});
